import React, { ReactNode, RefObject, useState } from "react";
import { CursorState } from "../../providers/CursorProvider";
import { CursorComponent } from "./CursorComponent";

interface SmashProps {
    children: ReactNode;
    className ?: string;
    style ?: React.CSSProperties;
    loot ?: ReactNode;
    onSmash ?: () => void;
    stateRef ?: RefObject<boolean>;
}

export function Smashable (props : SmashProps) {
    const [smashed, setSmashed] = useState(false);

    const className = props.className !== undefined ? props.className : "";
    const style = props.style !== undefined ? props.style : {};

    return <div className={className} style={style}>
        { (smashed && props.loot !== undefined) ? props.loot : null }
        <div className={smashed ? 'smash-post' : 'smash-pre'}>
            <CursorComponent cursor={CursorState.HAM} onClick={() => {
                setSmashed(true);
                if (props.stateRef !== undefined)
                    props.stateRef.current = true;
                if (props.onSmash !== undefined)
                    props.onSmash();
            }}>
                {props.children}
            </CursorComponent>
        </div>
    </div>
}